import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=2e946be6"
import script from "./ContactPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports